export default __webpack_public_path__ + "static/landing-page-755216421a0dcd8c1fd4b6deb627d670.jpg";